import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { useNavigate, useOutletContext } from "react-router-dom";
import "./commonqueriespage.css";
import ProfileHeader from "../../profile/components/ProfileHeader";
import { ArrowLeft } from "lucide-react";

const faqs = [
  {
    question: "How to track commission?",
    answer:
      "You can track your commission from the dashboard under the earnings section. All approved commissions are updated in real-time.",
  },
  {
    question: "Lead qualification criteria",
    answer:
      "A lead is considered qualified when the client completes verification and meets the eligibility criteria defined by the company.",
  },
  {
    question: "Marketing asset request",
    answer:
      "You can request marketing assets by emailing the support team or using the Email Support page available in your dashboard.",
  },
  {
    question: "Payment processing timeline",
    answer:
      "Payments are processed within 5–7 working days after commission approval and are credited directly to your registered bank account.",
  },
];

const CommonQueriesPage = () => {
  const { openSidebar } = useOutletContext();
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="rp-support-page">
      <ProfileHeader onMenuClick={openSidebar} val="Common Queries" />
       <div className="rp-support-actions">
          <button onClick={()=>navigate('/supports')}  type="button" className="rp-create-leads-save-btn">
             <ArrowLeft size={16}/> Back
          </button>
        </div>
      <div className="rp-faq-card">
        {faqs.map((item, index) => (
          <div className="rp-faq-item" key={index}>
            <div
              className="rp-faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span>{item.question}</span>
              <FiChevronDown
                className={`rp-faq-arrow ${
                  activeIndex === index ? "open" : ""
                }`}
              />
            </div>

            {activeIndex === index && (
              <div className="rp-faq-answer">
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommonQueriesPage;
